import React, { useEffect, useState } from "react";
import {
  useNavigate,
  useParams,
} from "react-router-dom";
import { Form, Label, Input, FormGroup, Button } from "reactstrap";
import "../form.css";
import "bootstrap/dist/css/bootstrap.css";
import WorkoutApi from "../Api";

const WorkoutEditForm = () => {
  const { id } = useParams();
  let navigate = useNavigate();
  console.log(id);
  let newUser = JSON.parse(localStorage.getItem("user"));

  const [workoutData, SetWorkout] = useState(null);
  const [fData, setFormData] = useState("");

  useEffect(() => {
    WorkoutApi.getWorkout(newUser.id, id).then((res) => {
      setFormData(res);
    });
  }, []);

  const handleChange = (evt) => {
    const { name, value } = evt.target;
    setFormData((fData) => ({
      ...fData,
      [name]: value,
    }));
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();

    WorkoutApi.patchWorkout(newUser.id, id, { ...fData }).then((res) => {
      console.log("res", res);
    });

    alert(
      ` user ${fData.name}, password ${fData.description}, first name ${fData.user_id}`,
    );
    navigate("/");
  };

  return (
    <>
      <h2> Workouts</h2>
      <h3 className="formHeader">
        Register to start planning your workouts today!
      </h3>
      <Form className="formBody" onSubmit={handleSubmit}>
        <FormGroup>
          <Label className="labelTitle" htmlFor="name">
            Name
          </Label>
          <Input
            id="name"
            name="name"
            placeholder="Create a name for your workout here"
            type="text"
            value={fData.name}
            onChange={handleChange}
          />
        </FormGroup>
        <FormGroup>
          <Label className="labelTitle" htmlFor="description">
            Description
          </Label>
          <Input
            id="description"
            name="description"
            placeholder="Describe your workout here"
            type="text"
            value={fData.description}
            onChange={handleChange}
          />
        </FormGroup>
        <Button color="primary">Submit</Button>
      </Form>
    </>
  );
};

export default WorkoutEditForm;
